import globals from "../globals";

// Navbar Mixin
export default {
  data() {
    return {
        warning_msg:"",
        connectionsList: [],
    };
  },
  methods: {
    // Getting Request
    getConnectionRequests() {
      this.ajaxCallinprogress = true;
      this.$http
        .post("/notifications/get_connection_request", {
          skip: this.skip,
          limit: this.limit,
          search_key: this.search_key,
        })
        .then(res => {
          if (res.data.status_id == 1) {
            this.connectionsList = res.data.response;
            this.ajaxCallinprogress = false;
          }
        });
    },
    getHierarchyListView(params) {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await this.$http.post(globals.AUTH_SERVICE + "/organization/companies/hierarchy", params);
                if (response.data.status_id == 1) {
                    resolve(response.data)
                } else {
                    reject(response.reason)
                    this.warning_msg = response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }
            catch (error) {
                this.warning_msg = error.response.data.reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        })
    },
    switchCompany(params) {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await this.$http.post(globals.AUTH_SERVICE + `/auth/company/switch`, params);
                if (response.data.status_id == 1) {
                    resolve(response.data)
                } else {
                    reject(response.reason)
                    this.warning_msg = response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }
            catch (error) {
                this.warning_msg = error.response.data.reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        })
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/navbarMixin.js